export default {
	/* 首页 */
	userRegion: '/web/common/getUserRegion',                           //获取当前用户区域范围
	homeSwiper: `website/bannerList`,																	// 首页轮播图
	recommendArtworkList: `/website/recommendArtworkList`,						// 推荐艺术品
	recommendArtistList: `/website/recommendArtistList`,							// 推荐艺术家列表
	
	/* 艺术家 */
	informationList: `website/informationList`,												// 艺术家咨询列表
	artistLabelList: `website/artistLabelList`,												// 艺术家标签列表
	artworkListByArtistId: `/website/artworkListByArtistId`,					// 根据艺术家id获取艺术品列表
	getArtistById: `/website/getArtistById`,													// 根据艺术家ID获取艺术家详情
	artistList: `/website/artistList`,																// 艺术家列表
	getInformationById: `/website/getInformationById`,								// 根据id获取咨询详情
	
	/* 艺术品 */
	artworkList: `/website/artworkList`,															// 艺术品列表
	worksDetails: `website/worksDetails`,															// 艺术品图文详情、评价
	artwork: `/website/artwork`,																			// 艺术品信息
	artworkKindList: `/website/artworkKindList`,											// 艺术品分类列表

	/* APP分享艺术品详情页接口 */
	appArtworkDetails: `/api/member/artwork/details`,									//APP查询艺术品详情
	appWorksDetails: `/api/member/artwork/worksDetails`,							//艺术品图文详情、评价
	appArtistDetail: `/api/member/artist/details`,										//查询艺术家简介
	appArtistArtworkList: `/api/member/artist/artworkList`,						//查询艺术家的艺术品列表
	appMessageList: `/api/artwork/message/list`,													//查询艺术品留言列表
	
	// 分享注册
	smsAreaList: `/api/common/sms/smsAreaList`,//查询短信地区编码
	register: `/api/member/user/register`,//用户注册
	smsSend: `/api/common/sms/smsSend`,//发送验证码
	agreement: `/api/member/ContentManage/contentManage`,//平台注册协议
	areaList: `/website/smsAreaList`,//查询短信地区编码

  
	/* APP分享视频详情 */
	appVideoDetails: `/api/member/video/getVideo`,	
	appCommentList: `/api/member/video/commentList`,	
	appPlayInfo: `/api/member/videoFile/getPlayInfo`,	

  // 活动相册
  photoCategory: `/website/albumClassifyList`, // 相册分类
  photoList: `/website/albumList`, // 相册列表

  // 分享购物车
  appShoppingCartList: `/website/artworkShareList`
	
}